import { render, staticRenderFns } from "./member_group.vue?vue&type=template&id=42e264d4&scoped=true"
import script from "./member_group.vue?vue&type=script&lang=js"
export * from "./member_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e264d4",
  null
  
)

export default component.exports